namespace Matrix.Data {
    export namespace SecurityMergeService {
        export const baseUrl = 'Data/SecurityMerge';

        export declare function Create(request: Serenity.SaveRequest<SecurityMergeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SecurityMergeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BatchReview(request: BatchReviewRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AssignNewSecurityId(request: AssignNewSecurityIdRequest, onSuccess?: (response: AssignNewSecurityIdResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function EditSMPrimarySecurityOverriden(request: EditSMPrimarySecurityOverridenRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SecurityMergeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: SecurityMergeListRequest, onSuccess?: (response: Serenity.ListResponse<SecurityMergeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PublishChanges(request: Serenity.OperationServiceRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PublishChangesCancel(request: Serenity.OperationCancelRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PublishChangesStatus(request: Serenity.OperationStatusRequest, onSuccess?: (response: Serenity.OperationStatusResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/SecurityMerge/Create",
            Update = "Data/SecurityMerge/Update",
            BatchReview = "Data/SecurityMerge/BatchReview",
            AssignNewSecurityId = "Data/SecurityMerge/AssignNewSecurityId",
            EditSMPrimarySecurityOverriden = "Data/SecurityMerge/EditSMPrimarySecurityOverriden",
            Delete = "Data/SecurityMerge/Delete",
            Retrieve = "Data/SecurityMerge/Retrieve",
            List = "Data/SecurityMerge/List",
            PublishChanges = "Data/SecurityMerge/PublishChanges",
            PublishChangesCancel = "Data/SecurityMerge/PublishChangesCancel",
            PublishChangesStatus = "Data/SecurityMerge/PublishChangesStatus"
        }

        [
            'Create', 
            'Update', 
            'BatchReview', 
            'AssignNewSecurityId', 
            'EditSMPrimarySecurityOverriden', 
            'Delete', 
            'Retrieve', 
            'List', 
            'PublishChanges', 
            'PublishChangesCancel', 
            'PublishChangesStatus'
        ].forEach(x => {
            (<any>SecurityMergeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
